import { useMutation } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useAppendNote = function (_a) {
    var noteId = _a.noteId, onSuccess = _a.onSuccess, onError = _a.onError;
    var axios = useAxios();
    return useMutation(function (values) {
        return axios
            .request({
            method: 'POST',
            data: values,
            url: "/api/v1/notes/".concat(noteId, "/appendments"),
        })
            .then(function (response) {
            if (response.status === 201) {
                return axios.request({
                    method: 'POST',
                    url: "/api/v1/note_appendments/".concat(response.data.data.id, "/sign"),
                });
            }
            return response;
        });
    }, {
        onError: onError,
        onSuccess: function (_a, variables) {
            var data = _a.data;
            onSuccess && onSuccess(data.data, variables);
        },
    });
};
